<template>
  <div class="header">
    <!-- <div class="lanChangBox">
      <div class="lanBox">
        <img src="./../assets/yuyan.png">
        <span @click="changeLan('cn')" :class="{'currentType':lanType=='cn'}">中文&nbsp;&nbsp;</span>
        /
        <span
          @click="changeLan('en')"
          :class="{'currentType':lanType=='en'}"
        >&nbsp;&nbsp;EN</span>
      </div>
    </div>-->
    <div class="content">
      <img src="../../assets/images/logo.png" style="width:213px;top:20px;" alt/>
      <div class="lanBox">
        <!-- <img src="../../assets/yuyan.png"/> -->
        <span @click="changeLan('cn')" :class="{'currentType':lanType=='cn'}">中文</span>
        <i style="padding-top:2px;margin-left:5px;margin-right:5px;font-size: 14px;">/</i>
        <span @click="changeLan('en')" :class="{'currentType'  :lanType=='en'}">EN</span>
      </div>
      <!-- <div class="spe"></div> -->
      <div class="menu">
        <router-link :tag="item.id==7?'span':'a'" :style="{'margin-left':$route.path.indexOf('en')==1?'6px':'10px'}" v-for="(item) of menuData"
                     :class="['menuItem','ft14',item.id==headerId?'active':'',item.id==7?'position':'',
                     $route.name == 'detailsProduct' && item.id==10 ? 'router-link-exact-active' : '',
                     $route.name == 'detailsOpenPlatform' && item.id==11 ? 'router-link-exact-active' : '',
                     ]"
                     :key="item.id"
                     :to="item.routerLink"
        >
          {{ lanInfo.menu[item.name] }}
          <div class="list-info">
          <div class="nextList" v-if="item.id==7 && $route.path.indexOf('cn')==1">
            <p v-for="(item) in dataCnLink.filter(item=>item.category==1)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
              <span :href="item.dapp_home_url" target="_blank" @click="nextTo(item.dapp_home_url)">{{ item.dapp_name }}</span>
            </p>
            <template v-if="dataEnLink.filter(item=>item.category==2).length">
              <span :class="['drawer-con-detail-item-line']" :style="{'border-top':'1px dotted rgba(0,0,0,0.5)'}">
              </span>
              <p v-for="(item) in dataCnLink.filter(item=>item.category==2)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
                 <span :href="item.dapp_home_url" target="_blank" @click="nextTo(item.dapp_home_url)">{{item.dapp_name}}</span>
              </p>
             </template>
             <template v-if="dataEnLink.filter(item=>item.category==4).length">
              <span class="text_desc">
                ----------------&nbsp;DAPP - APP&nbsp;-----------------
              </span>
               <p class="app-box" v-for="(item,index) in dataCnLink.filter(item=>item.category==4)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
                  <span  target="_blank" >{{item.dapp_name}}</span>
                  <span class="app-con">
                    <span class="app-con-item">
                      <img :src="item.menu_logo"/>
                      <!-- <span>{{ item.dapp_name }}</span> -->
                    </span>
                  </span>
              </p>
              </template>
              <template v-if="dataEnLink.filter(item=>item.category==3).length">
              <span class="text_desc">
               -------------&nbsp;相关电子诉讼平台&nbsp;-------------
              </span>
               <p v-for="(item,index) in dataCnLink.filter(item=>item.category==3)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
                  <span :href="item.dapp_home_url" target="_blank" @click="nextTo(item.dapp_home_url)">{{item.dapp_name}}</span>
              </p>
              </template>
             
           </div>
           <div class="nextList" v-if="item.id==7 && $route.path.indexOf('en')==1">
              <p v-for="(item,index) in dataEnLink.filter(item=>item.category==1)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
               <span :href="item.dapp_home_url" target="_blank" @click="nextTo(item.dapp_home_url)">{{item.dapp_name_en}}</span>
             </p>
              <template v-if="dataEnLink.filter(item=>item.category==2).length">
                <span :class="['drawer-con-detail-item-line']" :style="{'border-top':'1px dotted rgba(0,0,0,0.5)'}">
                </span>
                <p v-for="(item,index) in dataEnLink.filter(item=>item.category==2)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
                  <span :href="item.dapp_home_url" target="_blank" @click="nextTo(item.dapp_home_url)">{{item.dapp_name_en}}</span>
                </p>
              </template>
              <template v-if="dataEnLink.filter(item=>item.category==4).length">
              <span class="text_desc">
                ----------------&nbsp;DAPP - APP&nbsp;-----------------
              </span>
               <p class="app-box" v-for="(item,index) in dataCnLink.filter(item=>item.category==4)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
                  <span  target="_blank" >{{item.dapp_name_en}}</span>
                  <span class="app-con">
                    <span class="app-con-item">
                      <img :src="item.menu_logo"/>
                    </span>
                  </span>
              </p>
              </template>
              <template v-if="dataEnLink.filter(item=>item.category==3).length">
                <span class="text_desc">
                -------------&nbsp;Internet court&nbsp;-------------
                </span>
                <p v-for="(item,index) in dataEnLink.filter(item=>item.category==3)" v-if="item.display==1 && item.dapp_name !='legalXchain浏览器'" >
                    <span :href="item.dapp_home_url" target="_blank" @click="nextTo(item.dapp_home_url)">{{item.dapp_name_en}}</span>
                </p>
              </template>
             
           </div>
          </div>

          </router-link>
          <span class="enterpriseAuth-link"  @click="goEnterpriseAuth">
            <span class="cn-enterpriseAuth-text" v-if="$route.path.indexOf('cn/') ==1"></span>
            <span class="en-enterpriseAuth-text" v-if="$route.path.indexOf('en/') ==1"></span>
          </span>
        </div>
      </div>
    </div>
</template>
<script>
export default {
  props:{
    headerId:{
      type:String,
      default:'0',
    }
  },
  data() {
    return {
      routerChange:0,
      dataCnLink:[
        {
          index:1,
          dapp_name:"IP360全方位数据权益保护平台",
          dapp_home_url:"https://www.ip360.net.cn",
          category:1
        },
        {
          index:2,
          dapp_name:"Xcontract智能签约平台",
          dapp_home_url:"https://www.xcontract.cn",
          category:1
        },
        {
          index:3,
          dapp_name:"真相搜索",
          dapp_home_url:"http://www.truthso.com",
          category:1
        },
        {
          index:4,
          dapp_name:"真相取证APP",
          dapp_home_url:"http://www.truthso.com/aboutTruthso/products",
          category:1
        },
         {
          index:11,
          dapp_name:"区块链执法记录仪",
          dapp_home_url:"http://www.truthso.com/aboutTruthso/MobileArray",
          category:1
        },
        {
          index:5,
          dapp_name:"北京市方正公证处区块链取证公证平台",
          dapp_home_url:"http://www.bjnetnotary.com",
          category:2
        }, 
        {
          index:19,
          dapp_name:"北京市方圆公证处区块链取证公证平台",
          dapp_home_url:"http://fy.bjnetnotary.com",
          category:2
        },{
          index:19,
          dapp_name:"北京市精诚公证处电子数据存证系统",
          dapp_home_url:"https://jcyunzheng.com",
          category:2
        },{
          index:19,
          dapp_name:"广州市广州公证处区块链电子数据保...",
          dapp_home_url:"http://bq.gz-notary.com",
          category:2
        },{
          index:19,
          dapp_name:"广州市广州公证处区块链赋强公证系...",
          dapp_home_url:"http://fq.gz-notary.com",
          category:2
        },
        {
          index:6,
          dapp_name:"杭州互联网公证处电子证据保管平台",
          dapp_home_url:"https://www.netnotary.cn/index"
          ,category:2
        },
        {
          index:7,
          dapp_name:"广州市海珠公证处区块链取证公证平台",
          dapp_home_url:"http://www.hzgzc.cn/index",
          category:2
        },
        {
          index:8,
          dapp_name:"内蒙古痕迹电子证据保管平台",
          dapp_home_url:"http://39.107.110.94/index",
          category:2
        },
        {
          index:9,
          dapp_name:"温州市华东公证处区块链取证公证平台",
          dapp_home_url:"http://121.43.13.193/index",
          category:2
        },{
          index:20,
          dapp_name:"成都市国力公证处区块链取证公证平台",
          dapp_home_url:"http://gl.scglgzc.com/",
          category:2
        },
        {
          index:10,
          dapp_name:"沧州市渤海公证处区块链取证公证平台",
          dapp_home_url:"http://bhnetnotary.bhgzc.com/index",
          category:2
        },
        {
          index:16,
          dapp_name:"佛山市电子证据固化平台",
          dapp_home_url:"http://www.ec-owl.com",
          category:2
        },
        {
          index:17,
          dapp_name:"EC源数字备案平台",
          dapp_home_url:"http://www.ec-origin.com/",
          category:2
        },
        {
          index:18,
          dapp_name:"蓝信电子签约平台",
          dapp_home_url:"https://www.lanxin.cn/E-signing/index.html",
          category:2
        },
       
        // {
        //   index:12,
        //   dapp_name:"legalXchain司法联盟链",
        //   dapp_home_url:"https://www.legalxchain.com"
        // },
        {
          index:13,
          dapp_name:"北京互联网法院",
          dapp_home_url:"http://sspt.bjinternetcourt.gov.cn/cas/login",
          category:3
        },
        {
          index:14,
          dapp_name:"杭州互联网法院诉讼平台",
          dapp_home_url:"https://www.netcourt.gov.cn/",
          category:3
        },
        {
          index:15,
          dapp_name:"广州互联网法院",
          dapp_home_url:"https://ols.gzinternetcourt.gov.cn",
          category:3
        }
      ],
      dataEnLink:[
        {
          index:1,
          text:"IP360",
          link:"https://www.ip360.net.cn"
        },
        {
          index:2,
          text:"Xcontract",
          link:"https://www.xcontract.cn"
        },
        {
          index:3,
          text:"TruthSo",
          link:"http://www.truthso.com"
        },
        {
          index:4,
          text:"TruthApp",
          link:"http://www.truthso.com/aboutTruthso/products"
        },
         {
          index:11,
          text:"TruthRecorder",
          link:"http://www.truthso.com/aboutTruthso/MobileArray",
           line:true,
          dashed:"1px dotted rgba(0,0,0,0.5)",
        },
        {
          index:5,
          text:"BJFZNetNotary",
          link:"http://www.bjnetnotary.com"
        },
        {
          index:16,
          text:"BJFYNetNotary",
          link:"http://fy.bjnetnotary.com"
        },{
          index:16,
          text:"BJJCNetNotary",
          link:"https://jcyunzheng.com"
        },{
          index:16,
          text:"GZGZNetNotary",
          link:"http://bq.gz-notary.com"
        },{
          index:16,
          text:"GZGZ FuQiang Notarization",
          link:"http://fq.gz-notary.com"
        },
        {
          index:6,
          text:"HZGZC",
          link:"https://www.netnotary.cn/index"
        },
        {
          index:7,
          text:"HZNetNotary",
          link:"http://www.hzgzc.cn/index"
        },
        {
          index:8,
          text:"WZCCChina",
          link:"http://39.107.110.94/index"
        },
        {
          index:9,
          text:"ZWHNPO",
          link:"http://121.43.13.193/index"
        },
        {
          index:20,
          text:"CDGLNetNotary",
          link:"http://gl.scglgzc.com/"
        },
        {
          index:10,
          text:"BHNetNotary",
          link:"http://bhnetnotary.bhgzc.com/index",
        },
        {
          index:8,
          text:"FCPS DZZJGH",
          link:"http://www.ec-owl.com"
        },
        {
          index:9,
          text:"FCPS ECYSZBA",
          link:"http://www.ec-origin.com/"
        },
        {
          index:10,
          text:"Lanxin Electronic Signature",
          link:"https://www.lanxin.cn/E-signing/index.html",
           line:true,
          borderW:"100%",
        },
        // {
        //   index:12,
        //   text:"LegalXChain",
        //   link:"https://www.legalxchain.com"
        // },
        {
          index:13,
          text:"BJIC",
          link:"http://sspt.bjinternetcourt.gov.cn/cas/login"
        },
        {
          index:14,
          text:"HZICLP",
          link:"https://www.netcourt.gov.cn/"
        },
        {
          index:15,
          text:"GZCOTI",
          link:"https://ols.gzinternetcourt.gov.cn"
        }
      ],
      menuData: [
        { name: "home", id: "1", routerLink: "home" },
        { name: "blockBrowser", id: "2", routerLink: "blockChain" },
        { name: "internetCourt", id: "3", routerLink: "internetCourt" },
        { name: "validateQuery", id: "4", routerLink: "validateQuery" },
        {
          name: "evidenceExtraction",
          id: "5",
          routerLink: "evidenceExtraction"
        },
        {name: "solution", id: "6", routerLink: "solution"},
        {name: "alliance", id: "7", routerLink: "javascript:;"},
        {name: "whitePaper", id: "8", routerLink: "technology"},
        {name: "openPlatform", id: "11", routerLink: "openPlatform"},
        {name: "activityProduct", id: "10", routerLink: "activityProduct"},
        {name: "contactUs", id: "9", routerLink: "contact"},
      ],
      isChangeHeader:true,
      id: 1,
      lanVal:"cn"
    };
  },
  computed:{
    lanType() {
        return this.$store.getters.getLanType;
    },
    lanInfo() {
      return this.$store.getters.getLanInfo;
    },
  },methods: {
      changeLan(flag) {
        let toUrl = this.$route.path.substr(4);
        let url = `/${flag}/` + toUrl;
        if (this.$route.query.id) {
          url = `/${flag}/` + toUrl + `?id=${this.$route.query.id}`;
        }
        this.lanVal=flag;
        this.$router.push(url);
      },
      nextTo(link){
        window.open(link,'_blank')
      },
      //获取产品链接
      getUrlList(){
        this.lanVal=this.$route.path.substr(1,2);
        console.log(this.lanVal)
        this.$ajax
        .get("/webapi/blockchainDapp/queryDappMenu")
        .then(res => {
          if (res.data.code == 200) {
            this.dataCnLink=res.data.extraData.menuList;
            this.dataEnLink=res.data.extraData.menuList;
          }
        });
      },
      hoverLink(){
        let _this=this;
        $(".position").hover(function(){
          $(".list-info").css({'height':((_this.dataCnLink.filter(item=>item.display==1).length)*30+30)+'px', 'overflow-y': 'visible','overflow-x': 'visible',"position": "absolute","top": "35px","left": "-20px",'z-index':'999999999999'});
          $(".list-info .app-box").hover(function(e){
            e.stopPropagation()
            $(this).find('.app-con').css({'display':'block','top': ($(this).offset().top - 50)+'px'});
          },function(){
            $(this).find('.app-con').css({'display':'none','top': ($(this).offset().top - 50)+'px'});
          });
        },function(){
          $(".list-info").css({'height':'0px','overflow-y': 'hidden','overflow-x': 'hidden'});
        });
      },
      goEnterpriseAuth(){
        this.$router.push(`/${this.lanVal}/enterpriseAuth`);
      }
  },
  created(){
    this.getUrlList();
  },
  mounted(){
    this.hoverLink();
  },
}
</script>
<style lang="scss">
  .header {
    width: 100%;
    position: relative;
   z-index: 10;
    // height: 90px;
    // .lanChangBox {
    //   height: 30px;
    //   line-height: 30px;
    //   background: #e5e9ef;
    //   font-size: 14px;
    .currentType {
      color: #0a57c9;
    }
    .lanBox {
      float: right;
      padding-top: 3px;
      // filter: grayscale(100%);
      //       -webkit-filter: grayscale(100%);
      //       -moz-filter: grayscale(100%);
      //       -ms-filter: grayscale(100%);
      //       -o-filter: grayscale(100%);
      //       -webkit-filter: grayscale(1);
      //       filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
      //       filter: gray;
      img {
        width: 15px;
        height: 15px;
        margin-right: 10px;
        margin-top: 4px;
      }
      span {
        cursor: pointer;
        line-height: 55px;
        font-size: 12px;
      }
      // width: 1200px;
      margin: 0 auto;
      // display: flex;
      // justify-content: flex-end;
      // align-items: center;
    }
    // }
    .content {
      width: 1200px;
      height: 60px;
      margin: 0 auto;
      img {
        position: relative;
        top: 16px;
        float: left;
        // filter: grayscale(100%);
        //     -webkit-filter: grayscale(100%);
        //     -moz-filter: grayscale(100%);
        //     -ms-filter: grayscale(100%);
        //     -o-filter: grayscale(100%);
        //     -webkit-filter: grayscale(1);
        //     filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
        //     filter: gray;
      }
      .spe {
        float: right;
        height: 14px;
        width: 2px;
        margin: 23px 10px 0 10px;
        background-color: #d0caca;
      }
      .menu {
        float: right;
        position: relative;
        z-index: 1;
        top: 14px;
        margin-right: 9px;
        // filter: grayscale(100%);
        //     -webkit-filter: grayscale(100%);
        //     -moz-filter: grayscale(100%);
        //     -ms-filter: grayscale(100%);
        //     -o-filter: grayscale(100%);
        //     -webkit-filter: grayscale(1);
        //     filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
        //     filter: gray;
            color: #0a57c9;
        .menuItem {
          font-size: 12px;
          display: inline-block;
          padding: 10px 2px;
          margin-left: 10px;
          cursor: pointer;
          color: #333;
          
          &:hover {
         
          }
        }
        .position{
          position: relative;
          font-size: 12px;
          display: inline-block;
          padding: 10px 2px;
          margin-left: 10px;
          cursor: pointer;
          color: #333;
          .list-info{
            width: 232px;
            height: 0px;
            position: absolute;
            top:40px;
            left: -20px;
            // transition:all 0.3s;
            background:rgba(255,255,255,1);
            overflow: hidden;
            overflow-x: visible;
            z-index: 99999999 !important;
            border:0px;
            // box-shadow:0px 4px 6px 0px transparent;
            &::-webkit-scrollbar{
              width:5px;
            }
            &::-webkit-scrollbar-thumb{
              background: #ccc;
              border-radius:10px;
            }
          }
          .nextList{
            width: 232px;
            height: auto;
            // position: absolute;
            // top:40px;
            // left: -20px;
            transition:all 0.3s;
            // background:rgba(255,255,255,1);
            overflow: hidden;
            // z-index: 99999999 !important;
            // border:1px solid transparent;
            // box-shadow:0px 4px 6px 0px transparent;
            // filter: grayscale(100%);
            // -webkit-filter: grayscale(100%);
            // -moz-filter: grayscale(100%);
            // -ms-filter: grayscale(100%);
            // -o-filter: grayscale(100%);
            // -webkit-filter: grayscale(1);
            // filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
            // filter: gray;
            p{
              width: 100%;
              box-sizing: border-box;
              // height:32px;
              font-family:Microsoft YaHei;
              font-weight:400;
              span{
                font-size:12px;
                color:rgba(50,50,50,1);
                display: block;
                width: 99%;
                height: 28px;
                line-height: 28px;
                box-sizing: border-box;
                padding-left: 13px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
            .text_desc{
              font-size:12px;
              color:#aaa;
              display: block;
              width: 100%;
              height: 28px;
              line-height: 28px;
              box-sizing: border-box;
              padding-left: 13px;
              
            }
            p:hover span:nth-child(1){
              color: #0957C9;
               background:#f5f5f5;
            }
            p:last-child{
              margin-bottom: 10px;
            }
            p:first-child{
              margin-top: 10px;
            }
            .drawer-con-detail-item-line{
              box-sizing: border-box;
              margin: 6px auto;
              // border-bottom: 1px solid rgba(255,255,255,0.2);
              display: block;
              width: 205px;
              height: 1px;
              background: none;
              text-align: center;
            }
            .app-con{
              height: 90px;
              transition:height 0.3s;
              display:block;
              width:60%;
              // display: flex;
              background: #f5f5f5;
              // align-items: center;
              // justify-content: center;
              line-height: 20px !important;
              padding-left: 0px;
              text-align: center;
              position: absolute;
              display: none;
              left: 229px;
              z-index: 99999999;
              border:1px solid rgba(220, 220, 220, 1);
              img{
                width: 70px;
                display:inline-block;
                height:70px;
                margin:0 auto;
                top:5px;
                float: none;
              }
              .app-con-item{
                font-size: 12px;
                font-weight: 400;
                color: #323232;
                padding-left: 0px;
                width: 100%;
                height: auto;
                background:#f5f5f5 !important;
                line-height: 20px !important;
                padding-top: 5px;
                span{
                 padding-left:0px;
                }
              }
            }
          }
        }
        .position:hover .list-info{
            // height:532px;
            border:1px solid rgba(220, 220, 220, 1);
            // box-shadow:0px 4px 6px 0px rgba(0, 0, 0, 0.4);
        }
        .active{
           border-bottom: 2px solid #0a57c9;
           color: #0a57c9;
          //  filter: grayscale(100%);
          //   -webkit-filter: grayscale(100%);
          //   -moz-filter: grayscale(100%);
          //   -ms-filter: grayscale(100%);
          //   -o-filter: grayscale(100%);
          //   -webkit-filter: grayscale(1);
          //   filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
          //   filter: gray;
        }
        .router-link-exact-active {
          border-bottom: 2px solid #0a57c9;
          color: #0a57c9;
          // filter: grayscale(100%);
          //   -webkit-filter: grayscale(100%);
          //   -moz-filter: grayscale(100%);
          //   -ms-filter: grayscale(100%);
          //   -o-filter: grayscale(100%);
          //   -webkit-filter: grayscale(1);
          //   filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
          //   filter: gray;
        }
        .enterpriseAuth-link{
            cursor:pointer;
            .cn-enterpriseAuth-text{
              display: inline-block;
              width: 92px;
              height: 24px;
              float: right;
              margin-top:5px;
              margin-left: 15px;
              background: url(../../assets/images/enterpriseAuth/cn-text-nor.png) no-repeat;
              background-size: 100% 100%;
              &:hover{
                background: url(../../assets/images/enterpriseAuth/cn-text-hor.png) no-repeat;
              background-size: 100% 100%;
              }
            } 
            .en-enterpriseAuth-text{
              display: inline-block;
              width: 92px;
              height: 24px;
              float: right;
              margin-top:5px;
              margin-left: 5px;
              background: url(../../assets/images/enterpriseAuth/en-text-nor.png) no-repeat;
              background-size: 100% 100%;
              &:hover{
                background: url(../../assets/images/enterpriseAuth/en-text-hor.png) no-repeat;
              background-size: 100% 100%;
              }
            } 
        }
      }
    }
  }
</style>



"menuList": [
  {
    "menu_logo": "https://legalxchain.oss-cn-beijing.aliyuncs.com/res/files/dapp/logo/menu_logo/1_menu_logo.png",
    "partner_id": 1,
    "display": 1,
    "dapp_name": "IP360全方位数据权益保护平台",
    "description": "IP360是真相科技基于区块链、云计算、大数据及人工智能技术自主开发的全方位数据权益保护开放式平台。",
    "id": 1,
    "dapp_name_en": "IP360",
    "title_logo": "https://legalxchain.oss-cn-beijing.aliyuncs.com/res/files/dapp/logo/1_title_log.png",
    "category": 1,
    "dapp_home_url": "https://test.ip360.org ",
    "seq": 1,
    "appData":{
      "name_en":"",
      "name_cn":"沪E存区块链电子证据保全",
      "appInfo":[
        {
          "imgURl":"app.png",
          "name_en":"Android+iOS",
          "name_cn":"沪E存APP",
        },
        {
          "imgURl":"",
          "name_en":"",
          "name_cn":"",
        }
      ]
    }
  }
]